import React from "react";

import { withStyleProps } from "Utils/styleProps";

import SwapVerticalArrowsIcon from "./svg/swap_vert-24px.svg";

type Props = {
  icon: string;
};
export class SwapVerticalArrowsIconComponent extends React.Component<Props> {
  render() {
    return <SwapVerticalArrowsIcon {...this.props} />;
  }
}
export default withStyleProps(SwapVerticalArrowsIconComponent);
